import jwtDecode from "jwt-decode";

export default class AuthData
{
	constructor(securityGroup, clear = false)
	{
		this.token = "";
		this.decodedToken = {};
		this.securityGroup = securityGroup;
		if (clear)
			sessionStorage.removeItem("accessToken");
		else
		{
			this.recoverSession();
		}
	}

	recoverSession()
	{
		const savedToken = sessionStorage.getItem("accessToken");

		if (savedToken !== null)
		{
			try
			{
				const data = JSON.parse(sessionStorage.getItem("accessToken"));
				this.token = data.token;
				this.decodedToken = data.decodedToken;
			}
			catch (e)
			{
				console.error("Security Token invalid");
			}
		}
	}

	setToken(token)
	{
		try
		{
			this.decodedToken = jwtDecode(token);
			if (!this.validateSecurityGroups())
			{
				this.decodedToken = {};
				return false;
			}
			this.token = `Bearer ${token}`;
		}
		catch (ex)
		{
			console.error(ex.error);
			return false;
		}
		return true;
	}

	validateSecurityGroups()
	{
		const sg = this.securityGroup.map(group => group.toUpperCase());
		let ret = false;
		if (this.decodedToken && this.decodedToken["cognito:groups"] && this.decodedToken["cognito:groups"].length > 0)
		{
			ret |= sg.some(group => this.decodedToken["cognito:groups"].includes(group))
		}

		return ret;
	}
}
